// copied from theme.js
var cachedMap2 = new Map();
function cachedFetch2(url, options) {
  const cacheKey = url;
  if (cachedMap2.has(cacheKey)) {
    return Promise.resolve(new Response(new Blob([cachedMap2.get(cacheKey)])));
  }
  return fetch(url, options).then((response) => {
    if (response.status === 200) {
      const contentType = response.headers.get("Content-Type");
      if (contentType && (contentType.match(/application\/json/i) || contentType.match(/text\//i))) {
        response.clone().text().then((content) => {
          cachedMap2.set(cacheKey, content);
        });
      }
    }
    return response;
  });
}
// copied from theme.js
var abortController2 = null;
document.addEventListener("facet:updatenoscroll", async (event) => {
  if (abortController2) {
    abortController2.abort();
  }
  abortController2 = new AbortController();
  const url = event.detail.url, shopifySection = document.getElementById(`shopify-section-${url.searchParams.get("section_id")}`);
  const clonedUrl = new URL(url);
  clonedUrl.searchParams.delete("section_id");
  history.replaceState({}, "", clonedUrl.toString());
  try {
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    const tempContent = new DOMParser().parseFromString(await (await cachedFetch2(url.toString(), { signal: abortController2.signal })).text(), "text/html");
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    const newShopifySection = tempContent.querySelector(".shopify-section");
    /*newShopifySection.querySelectorAll('[is="facets-form"] details').forEach((detailsElement) => {
      const inputNames = [...new Set(Array.from(detailsElement.querySelectorAll('input[name*="filter."]'), (item) => item.name))];
      inputNames.forEach((inputName) => {
        detailsElement.open = openDetailsValues.has(inputName);
      });
    });*/
    shopifySection.replaceChildren(...document.importNode(tempContent.querySelector(".shopify-section"), true).childNodes);
    document.documentElement.dispatchEvent(new CustomEvent("facet:updatenoscroll:end", { bubbles: true }));
  } catch (e) {
    throw e;
  }
});

function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

/****************************************************
  custom filter menu on collection grids / PLP
 ****************************************************/
var customCollectionMenu = {
  wrapper: null,
  init: function () {
    this.wrapper = $('.collection--custom-menu');
    if (this.wrapper.length) {
      this.bindLinkEvents();
      this.bindScrollEvent();
    }  
    document.addEventListener("facet:updatenoscroll", (event) => { setTimeout(customCollectionMenu.bindScrollEvent, 500); });
  },
  bindLinkEvents: function () {
    var mainCollectionDiv = $('.shopify-section--main-collection');
    var sectionId = mainCollectionDiv.attr('id').replace("shopify-section-", "");
    mainCollectionDiv.on('click.custommenu', '.collection--custom-menu a', function (e) {
      e.preventDefault();
      var url = new URL(this.href);
      url.searchParams.set("section_id", sectionId);
      this.dispatchEvent(new CustomEvent("facet:updatenoscroll", {
        bubbles: true,
        detail: {
          url
        }
      }));        
    });
  },
  bindScrollEvent: function () {
    //var doScroll = (typeof scrollToActive !== 'undefined') ? scrollToActive : true;
    var scrollArea = $('.collection--custom-menu .is-scrollable');
    if (scrollArea.length) {
      //window.console.log('doScroll',doScroll);
      scrollArea.scrollLeft(0);
      var isOverflow = scrollArea[0].scrollWidth > scrollArea[0].clientWidth;
      scrollArea.toggleClass('has-overflow', isOverflow);

      var activeLink = scrollArea.find('.is-active');
      if (activeLink.length) {
        if (!activeLink.is(':first-child') && !activeLink.hasClass('is-root')) {
          activeLink[0].scrollIntoView({ behavior: "instant", block: "nearest", inline: "center" });
        }
      }
      
      scrollArea.on('scroll', function () {
        //window.console.log('on scroll', this.scrollLeft);
        if (this.scrollLeft <= 1) {
            scrollArea.removeClass('scrolledMid').removeClass('scrolledEnd');
        } else if (Math.floor(this.scrollWidth - this.scrollLeft) <= this.offsetWidth) {
            scrollArea.removeClass('scrolledMid').addClass('scrolledEnd');
        } else {
            scrollArea.removeClass('scrolledEnd'); //.addClass('scrolledMid');
        }
      });
    }
  }
};
/****************************************************
   END: custom filter menu on collection grids / PLP
 ****************************************************/

/****************************************************
 in-grid content on PLP
 ****************************************************/
var gridContent = {
  init: function () {
    if ($('.collection__main > .product-list').length && $('.grid-content').length) {
      // run on init
      this.matchHeight();
      
      // also on layout switch
      $('.collection-toolbar__layout-switch-list[device="desktop"]').on('click', 'button', function () {
        setTimeout(function () {
          gridContent.matchHeight();
        }, 500);
      });

      // and on resize
      window.addEventListener("resize",debounce(function(e){
        gridContent.matchHeight();
      }));
    }
  },
  matchHeight: function () {
    if (window.matchMedia(window.themeVariables.mediaQueries['sm']).matches) {
      var h = $('.collection__main .product-card__image').height();
      $('.collection__main .grid-content-image-wrapper').height(h);
    } else {
      $('.collection__main .grid-content-image-wrapper').removeAttr('style');
    }
  }
};
/****************************************************
   END: in-grid content on PLP
 ****************************************************/

/****************************************************
 Add color swatches to Product on PDP
 ****************************************************/
var pdpColorOptionDiv = null;
var pdpAllVariants = null;
var pdpAllProdsForSku = [];
function initPDPOtherColors() {
  //console.log('initPDPOtherColors');
  pdpAllVariants = [];
  
  pdpColorOptionDiv = $('.variant-picker__option.option-color');
  var variantPicker = pdpColorOptionDiv.closest('.variant-picker');
  
  var masterSku = variantPicker.data('master-sku');
  if (masterSku) {
    //console.log('has MasterSku tag', masterSku);
    fetch(window.themeVariables.urls.all_products_collection.concat("/".concat(masterSku), "?view=data"))
    .then((response) => response.json())
    .then((data) => pdpBuildColorSwatches(data));
  } else {
    //console.log('No MasterSku tag', masterSku);    
  }
  
}
function pdpBuildColorSwatches(data) {
  //console.log('pdpBuildColorSwatches', data);
  pdpAllProdsForSku = data.products;
  
  var jsonElement = $('<script type="application/json" id="product-mastersku--json" />');
  var allprodsJson = JSON.stringify(data.products);
  jsonElement.html(allprodsJson);
  $('.product-info').append(jsonElement);

  var hideOOSColors = false; //JSON.parse(pdpColorOptionDiv.attr('data-hide-oos-swatches'));
  
  var variantPicker = pdpColorOptionDiv.closest('.variant-picker');
  var formId = variantPicker.attr('form');

  var colorUL = pdpColorOptionDiv.find('.variant-picker__option-values');
  var radiosName = colorUL.data('option-name');
  var selectedRadio = colorUL.find('input[type=radio]:checked');
  var selectedLabel = colorUL.find('label[for="' + selectedRadio.attr('id') + '"]');
  var currentColor = selectedRadio.val();
  //console.log('currentColor', currentColor);
  if (data.products.length > 1) {
    //pdpColorOptionDiv.closest('.ProductForm__Variants').prepend(pdpColorOptionDiv);
    //pdpColorOptionDiv.removeClass('ProductForm__Option--singlevalue');
  }
  for (var i = 0; i < data.products.length; i++) {
    var prod = data.products[i];
    if (!('selectedColor' in prod) || prod.selectedColor == '') {
      continue;
    }
    var prodSwatchUrl = prod.url;
    try {
      var temp = window.location.pathname.split('/');
      temp = temp.filter((str) => str !== '');        
      if (temp.indexOf('collections') > -1) {
        var productsIndex = temp.indexOf('products');          
        temp = temp.slice(0, productsIndex);            
        var temp2 = prod.url.split('/');
        temp2 = temp2.filter((str) => str !== '');  
        var urlarr = temp.concat(temp2);          
        var newurl = urlarr.join('/');            
        prodSwatchUrl = '/' + newurl;
      }
    } catch (ex) {}
    
    //console.log('prod.variants', prod.variants);
    pdpAllVariants.push.apply(pdpAllVariants, prod.variants);

    if (prod.selectedColor == currentColor) {
      selectedRadio.attr('data-sort', i);
      selectedLabel.attr('data-sort', i);
    } else { 
        if (!prod.available && hideOOSColors) {
          continue;
        }    
      
      var radioId = formId + '-' + radiosName + '-' + prod.selectedColor.handleize();
      
      var newRadio = $('<input class="sr-only" type="radio" />');        
      newRadio.attr('name', radiosName);
      newRadio.attr('id', radioId);
      newRadio.attr('form', formId);
      newRadio.attr('value', prod.selectedColor);
      newRadio.attr('data-sort', i);

      var newLabel = $('<label class="color-swatch rounded-full" data-option-value></label>');
      newLabel.attr('for', radioId);
      newLabel.attr('aria-label', prod.selectedColor);
      newLabel.attr('data-url', prodSwatchUrl);      
      newLabel.attr('data-sort', i);

      const swatch_color = prod.selectedColor.handleize();
      if (window.themeVariables.swatches[swatch_color] === undefined) {
        //swatch.style['background-color'] = swatch_color;
      } else {
        newLabel.attr('style', window.themeVariables.swatches[swatch_color]);
      }      

      var labelText = $('<span class="sr-only"></span>');
      labelText.text(prod.selectedColor);
      newLabel.append(labelText);
      
      colorUL.append(newRadio);
      colorUL.append(newLabel);
    }

    //theme.utils.setSwatchColors(colorUL[0].querySelectorAll('input'));
  };
  //window.console.log('pdpAllVariants', pdpAllVariants);
      
  colorUL.find('[data-sort]').sort(function(a, b) {
      //console.log('sort', a.dataset.sort, b.dataset.sort);
      return +a.dataset.sort - +b.dataset.sort;
  }).appendTo(colorUL);
  
  /*var jsonElement = $('[id*=variant--json]');
  var allvariantsJson = JSON.stringify(pdpAllVariants);
  jsonElement.html(allvariantsJson);
  $('.product-options--root').attr('data-variants-added', true);*/
  
  $(colorUL).off('.customcolors').on('click.customcolors', '.color-swatch', (event) => {
    var href = event.target.dataset['url'];
    if (href) {
      //href = window.location.protocol + '//' + window.location.host + href;
      //window.console.log('history update', href);
      // set up new URL in browser window
      history.replaceState({}, '', href);
  
      new Promise(() => {
        refreshProductSections(href)
      }).catch((err) => {
        console.log(err)
      })
    }
  });
}
const refreshProductSections = (link) => {
  //console.log('refreshProductSections', link);
  var currentProduct = pdpAllProdsForSku.find(p => link.indexOf(p.handle) > -1);
  //window.console.log('currentProduct', currentProduct);
  
  if ($('.js-smp-reload').length > 0) {
    $('.js-smp-reload').each(function (i, sectionItem) {
      // get section id
      const sectionId = sectionItem.id.replace('shopify-section-', '');
      //console.log('sectionId', sectionId);
      const newUrl = link + `?section_id=` + sectionId;
      //console.log('get newUrl', newUrl);

      window
        .fetch(newUrl)
        .then()
        .then((_) => _.text())
        .then((html) => {
          //console.log('got html for ', sectionId);
                    
          var newSection = $(html);
          //newSection.find('h1.product-page--heading').parent().removeAttr('data-transition-cropper data-transition-item data-transition-type');
          
          /*var jsonElement = newSection.find('[id*=variant--json]');
          var allvariantsJson = JSON.stringify(pdpAllVariants);
          jsonElement.html(allvariantsJson);*/
          
          var sectionContents = newSection.contents();
          
          const sectionElement = $('#shopify-section-' + sectionId);
          sectionElement.empty().append(sectionContents);

          
        })
        .then((_) => {
          
          initPDPOtherColors();

        })
    })
  }
}
/****************************************************
   END: Add color swatches on PDP
 ****************************************************/

/****************************************************
 Add color swatches to Product Tiles on PLP / grids
 ****************************************************/
var prodTilesObserver = null;
window.masterSkus = window.masterSkus || {};
function prodTilesWatchViewport() {
  //window.console.log('prodTilesWatchViewport');
  var prodTiles = document.querySelectorAll('.product-card:not(.viewport-observed)');
  var intersectOpt = { root: null, threshold: 0.4 };
  var handleIntersect = function(entries, observer) {
      var observedElements = [];
      var intersectCount = 0;
      entries.forEach(function(entry) {
          var observed = entry.target.classList.contains('viewport-observed');
          if (entry.isIntersecting) {
              if (observed){
                  // skip
              } else {
                  entry.target.classList.add('viewport-observed');
                  intersectCount++;
                  observedElements.push(entry.target);
              }
              //prodTilesObserver.unobserve(entry.target);
          }
      });
      if (intersectCount > 0) {                      
          //window.trigger('theme:producttile:viewed', observedElements);
          initProductTileSwatches(observedElements);
      }
  }
  if (prodTiles.length) {
    prodTilesObserver = new IntersectionObserver(handleIntersect, intersectOpt);
    prodTiles.forEach((item) => prodTilesObserver.observe(item));
  } else {
    //prodTilesObserver = null;
  }
}
function initProductTileSwatches(tiles) {
  //var tiles = $('.product-card[data-master-sku]:not([data-swatches-loaded])');
  //window.console.log('initProductTileSwatches count', tiles.length);
  
  if (tiles.length) {
    tiles.forEach((productTile) => {
      var $ptile = $(productTile);
      var masterSku = $ptile.data('master-sku');
      //window.console.log('each tile', productTile, masterSku);
      //$ptile.attr('data-swatches-loaded', true);
      if (masterSku) {
        // custom event is triggered in theme.js > ProductCard element
        /*$ptile.on(`theme:producttile:${masterSku}:variantsLoaded`,
          ({ detail: { products: t } }) => {
            window.console.log('handling variantsLoaded', masterSku); //, $ptile);
            prodTileBuildSwatches($ptile, t);
          }
        );*/

        /*if (window.masterSkus.hasOwnProperty(masterSku)) {
            window.console.log('hasOwnProperty', masterSku);
            var prods = window.masterSkus[masterSku];
            //handleMasterSkuResponse(data)

            prodTileBuildSwatches($ptile, prods);
        } else {*/
            //window.console.log('fetch', masterSku);
            var fetchUrl = window.themeVariables.urls.all_products_collection.concat("/MasterSku:".concat(masterSku), "?view=data");
            fetch(fetchUrl)
              .then((response) => response.json())
              .then((data) => {
                window.masterSkus[masterSku] = data.products;

                prodTileBuildSwatches($ptile, data.products);
              });
        //}
      } else {
        //window.console.log('~~~~~ NO MASTER SKU')
      }
    });
  }
}
function prodTileBuildSwatches(productTile, products) {
  //window.console.log('prodTileBuildSwatches', productTile.attr('data-swatches-loaded'));
  if (productTile.attr('data-swatches-loaded') == true || productTile.attr('data-swatches-loaded') == 'true') {
    //window.console.log('already loaded');
    return;
  }
  productTile.attr('data-swatches-loaded', true);
  
  var hideOOSColors = false;
  var colorUL = productTile.find('.product-card__swatches');
  var radiosName = colorUL.data('option-name');
  var selectedRadio = colorUL.find('input[type=radio]:checked');
  //window.console.log('selectedRadio.length', selectedRadio.length);
  if (selectedRadio.length == 0) {
    selectedRadio = colorUL.find('input[type=radio]:eq(0)');
  }
  //var radiosName = selectedRadio.attr('name');
  var currentColor = selectedRadio.val();
  //window.console.log('currentColor', currentColor);
  var selectedLabel = colorUL.find('label[for="' + selectedRadio.attr('id') + '"]');

  for (var i = 0; i < products.length; i++) {
    var prod = products[i];
      
    if (!('selectedColor' in prod) || prod.selectedColor == '') {
      continue;
    }
    var prodSwatchUrl = prod.url;
    /*window.console.log('prodSwatchUrl before',prodSwatchUrl);
    try {
      var temp = window.location.pathname.split('/');
      temp = temp.filter((str) => str !== '');        
      if (temp.indexOf('collections') > -1) {
        var productsIndex = temp.indexOf('products');          
        temp = temp.slice(0, productsIndex);            
        var temp2 = prod.url.split('/');
        temp2 = temp2.filter((str) => str !== '');  
        var urlarr = temp.concat(temp2);          
        var newurl = urlarr.join('/');            
        prodSwatchUrl = '/' + newurl;
      }
    } catch (ex) {}
    window.console.log('prodSwatchUrl after',prodSwatchUrl);*/

    //window.console.log('prod.selectedColor', prod.selectedColor);
    if (prod.selectedColor == currentColor) {
      //window.console.log('selectedColor!!!', prod.selectedColor);
      selectedRadio.attr('data-sort', i);
      selectedLabel.attr('data-sort', i);
      selectedLabel.attr('data-url', prodSwatchUrl);
    } else {
      if (!prod.available && hideOOSColors) {
        continue;
      }    
      var radioId = radiosName + '-' + prod.selectedColor.handleize();
      
      var newRadio = $('<input class="sr-only" type="radio" />');        
      newRadio.attr('name', radiosName);
      newRadio.attr('id', radioId);
      //newRadio.attr('form', formId);
      newRadio.attr('value', prod.selectedColor);
      newRadio.attr('data-sort', i);

      var newLabel = $('<label class="color-swatch js-color-swatch rounded-full" data-option-value></label>');
      newLabel.attr('for', radioId);
      newLabel.attr('aria-label', prod.selectedColor);
      newLabel.attr('data-url', prodSwatchUrl);      
      newLabel.attr('data-sort', i);

      const swatch_color = prod.selectedColor.handleize();
      if (window.themeVariables.swatches[swatch_color] === undefined) {
        //swatch.style['background-color'] = swatch_color;
      } else {
        newLabel.attr('style', window.themeVariables.swatches[swatch_color]);
      }      

      var labelText = $('<span class="sr-only"></span>');
      labelText.text(prod.selectedColor);
      newLabel.append(labelText);
      
      colorUL.append(newRadio);
      colorUL.append(newLabel);
    }
  }

  colorUL.find('[data-sort]').sort(function(a, b) {
      //console.log('sort', a.dataset.sort, b.dataset.sort);
      return +a.dataset.sort - +b.dataset.sort;
  }).appendTo(colorUL);
  
  colorUL.off('.ptileswatch').on('click.ptileswatch', '.color-swatch', (event) => {
    var href = event.target.dataset['url'];
    //window.console.log('click href',href);
    if (href) {
      href = href.concat('?view=singlecard');
      //window.console.log('click href',href);
  
      new Promise(() => {
        refreshProductTile(productTile, href)
      }).catch((err) => {
        console.log(err)
      })
    }
  });    
}
function refreshProductTile(productTile, href) {  
  window
  .fetch(href)
  .then()
  .then((_) => _.text())
  .then((html) => {
    //console.log('got html for ', sectionId);
              
    var newSection = $(html);
    var newImages = newSection.find('.product-card__figure');
    var newInfo =  newSection.find('.product-card__info > *:not(.product-card__swatches)');
    
    // replace images
    productTile.find('.product-card__figure').replaceWith(newImages);
    
    // replace other elements, but do not replace swatches
    productTile.find('.product-card__info > *:not(.product-card__swatches)').each(function (i, el) {
      if (newInfo[i]) {
        el.replaceWith(newInfo[i]);
      } else {
        $(el).hide();
      }
    });

    
  })
  .then((_) => {
    initProductTileSwatches([ productTile ]);
  });
}
/****************************************************
   END: Add color swatches on PLP / grids
 ****************************************************/

$(document).ready(function () {
  gridContent.init();
  customCollectionMenu.init();  

  prodTilesWatchViewport(); // run once
  /*initProductTileSwatches();*/
  document.addEventListener("theme:loading:end", function() {
    //setTimeout(initProductTileSwatches, 500);
    setTimeout(prodTilesWatchViewport, 1000);
    //setTimeout(initProductTileSwatches, 1500);
  });

  if ($('.variant-picker__option.option-color').length) {
    initPDPOtherColors();
  }
});

function d3DomLoaded() {  
  document.getElementById('cart-drawer').addEventListener("dialog:after-show", function (e) { 
    if (typeof Rebuy !== "undefined" && typeof Rebuy["reinit"] !== "undefined") {
      Rebuy.reinit();
    }
  });
}

if (/complete|interactive|loaded/.test(document.readyState)) {
    d3DomLoaded();
} else {
    document.addEventListener('DOMContentLoaded', d3DomLoaded);
}

